/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createAsyncThunk } from "@reduxjs/toolkit";

import SignupApi from "~/features/signup/SignupApi";
import {
  PostCreateResellerRequestBody,
  PostResendVerifyEmailPayload,
  PostVerifyPayload,
} from "~/features/signup/types";
import createThunkError from "~/utils/createThunkError";
import getApiErrorCodeFromResponse from "~/utils/errors/getApiErrorCodeFromResponse";

export const signupAsync = createAsyncThunk("signup/createAccount", async (data: PostCreateResellerRequestBody) => {
  await SignupApi.postCreateReseller(data);

  return data.email;
});

export const verifyEmailAsync = createAsyncThunk("signup/verifyEmail", async (data: PostVerifyPayload, thunkAPI) => {
  const verifyRes = await SignupApi.postVerifyEmail(data);

  // Verify returns HTTP 200 and an error code as data
  const apiErrorCode = getApiErrorCodeFromResponse(verifyRes);
  if (apiErrorCode) {
    return thunkAPI.rejectWithValue(createThunkError({ apiErrorCode }));
  }

  return "verify.verify_success";
});

export const resendVerifyAsync = createAsyncThunk(
  "signup/resendVerify",
  async (data: PostResendVerifyEmailPayload, thunkAPI) => {
    const resendRes = await SignupApi.postResendVerifyEmail(data);

    // Resend returns HTTP 200 and an error code as data
    const apiErrorCode = getApiErrorCodeFromResponse(resendRes);
    if (apiErrorCode) {
      return thunkAPI.rejectWithValue(createThunkError({ apiErrorCode }));
    }

    return data.email;
  },
);
